export const export_api = {
  url: 'repurchaseListsDownload',
  title: '导出',
  method: 'post'
}

export const list_api = {
  url: 'repurchaseLists',
  title: '列表',
  method: 'post'
}

export const reCompute_api = {
  url: 'RecalRepurchaseDown',
  title: '重新计算购物',
  method: 'post'
}


// WEBPACK FOOTER //
// ./src/views/statistics/buy-again/desc.js